<template>
  <div class="production-page">
     <header>
      <div class="normal-header-block">
        <div class="container">
          <div class="slogan-container">
            <h1>全行业的数据化及AI转型升级解决方案</h1>
            <h2>咨询 / 工具 / 人才 / 众创</h2>
          </div>
        </div>
      </div>
    </header>
    <section>
      <div class="bg-block bg-industry">
        <div class="industry-container container">
          <div class="industry-header block-header">
            <h2>全行业解决方案</h2>
            <h3>Cross-industry Solutions</h3>
          </div>
          <div class="industry-icon-container">
            <div>
              <span class="iconfont icon-jinrong"></span>
              <p>金融银行</p>
            </div>
             <div>
              <span class="iconfont icon-zhengfu"></span>
              <p>机构政府</p>
            </div>
             <div>
              <span class="iconfont icon-zhihuichengshi"></span>
              <p>智慧城市</p>
            </div>
             <div>
              <span class="iconfont icon-zhinengzhizao"></span>
              <p>智能制造</p>
            </div>
             <div>
              <span class="iconfont icon-yiliaojiankang"></span>
              <p>医疗健康</p>
            </div>
             <div>
              <span class="iconfont icon-zhinenglingshou"></span>
              <p>新零售</p>
            </div>
             <div>
              <span class="iconfont icon-shujukexue"></span>
              <p>新技术</p>
            </div>
             <div>
              <span class="iconfont icon-zhuanxing"></span>
              <p>新能源</p>
            </div>
             <div>
              <span class="iconfont icon-jiaoyu"></span>
              <p>教育</p>
            </div>
             <div>
              <span class="iconfont icon-gongju"></span>
              <p>传媒</p>
            </div>
          </div>
          <div class="industry-backgound-container">
          </div>
          <div class="industry-list-container">
            <div class="block-header">
              <h2>和鲸的产品与服务</h2>
              <h3>Product and Service</h3>
            </div>
            <div class="industry-detait-container">
              <div class="industry-list-item">
                <div><h3>咨询</h3></div>
                <img src="https://cdn.kesci.com/client/solution/transformation.png">
                <img src="https://cdn.kesci.com/client/solution/consulting.png">
                <img src="https://cdn.kesci.com/client/solution/analyst.png">
              </div>
              <div class="custom-border"></div>
              <div class="industry-list-item">
                <div><h3>工具</h3></div>
                <img src="../assets/kescilab-color.png">
                <img src="https://cdn.kesci.com/client/solution/platform.png">
                <img>
              </div>
              <div class="custom-border"></div>
              <div class="industry-list-item">
                <div><h3>人才</h3></div>
                <img src="https://cdn.kesci.com/client/solution/branding.png">
                <img src="https://cdn.kesci.com/client/solution/recruit.png">
                <img src="https://cdn.kesci.com/client/solution/training.png">
              </div>
              <div class="custom-border"></div>
              <div class="industry-list-item">
                <div><h3>众创</h3></div>
                <img src="https://cdn.kesci.com/client/solution/crowd.png">
                <img src="https://cdn.kesci.com/client/solution/competition.png">
                <img src="https://cdn.kesci.com/client/solution/leadboard.png">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-block bg-solution">
        <div class="solution-container container">
          <div class="solution-header block-header">
            <h2>企业在不同的数据化及AI发展期,适合不同的产品与服务</h2>
            <h3>Flexible solutions for corporates in different stages of digitization</h3>
          </div>
          <div class="solution-slider-container">
            <div class="slider-card" :class="getCardClass(0, activeCard)" @click="handleClick(0)">
              <div class="card-header">
                <h3><span class="iconfont icon-shengji"></span>升级</h3>
              </div>
              <div class="card-block">
                <h4>扩大科技雇主品牌影响力</h4>
                <div class="collapse-block">
                  <p>领先别人一步，建立垂直领域的技术（雇主）品牌影响力</p>
                  <div class="card-img-container">
                    <img src="https://cdn.kesci.com/client/solution-white/branding.png">
                    <img src="https://cdn.kesci.com/client/solution-white/competition.png">
                  </div>
                </div>
              </div>
              <div class="custom-border"></div>
              <div class="card-block">
                <h4>提升AI发展效率、商业分析能力</h4>
                <div class="collapse-block">
                  <p>助力企业提升数据化及AI发展的商业价值</p>
                  <div class="card-img-container">
                    <img src="https://cdn.kesci.com/client/solution-white/consulting.png">
                    <img src="https://cdn.kesci.com/client/solution-white/analyst.png">
                  </div>
                </div>
              </div>
              <div class="custom-border"></div>
              <div class="card-block">
                <h4>引入专属数据创新平台</h4>
                <div class="collapse-block">
                  <p>构建企业自身的数据化及AI开发生产力</p>
                  <div class="card-img-container">
                    <img src="https://cdn.kesci.com/client/solution-white/platform.png">
                  </div>
                </div>
              </div>
            </div>
            <div class="slider-card" :class="getCardClass(-1, activeCard)" @click="handleClick(-1)">
              <div class="card-header">
                <h3><span class="iconfont icon-zhuanxing1"></span>转型</h3>
              </div>
              <div class="card-block">
                <h4>缺人才、缺团队、缺培训</h4>
                <div class="collapse-block">
                  <p>助力企业招募数据人才、组建AI团队，提供培训服务</p>
                  <div class="card-img-container">
                    <img src="https://cdn.kesci.com/client/solution-white/recruit.png">
                    <img src="https://cdn.kesci.com/client/solution-white/training.png">
                  </div>
                </div>
              </div>
              <div class="custom-border"></div>
              <div class="card-block">
                <h4>缺技术能力、缺创新氛围</h4>
                <div class="collapse-block">
                  <p>为企业、机构、园区、政府提供AI转型配套服务</p>
                  <div class="card-img-container">
                    <img src="https://cdn.kesci.com/client/solution-white/competition.png">
                  </div>
                </div>
              </div>
              <div class="custom-border"></div>
              <div class="card-block">
                <h4>缺战略规划与行动路径</h4>
                <div class="collapse-block">
                  <p>从战略到落地，全方位助力企业数据化及AI转型</p>
                  <div class="card-img-container">
                    <img src="https://cdn.kesci.com/client/solution-white/transformation.png">
                  </div>
                </div>
              </div>
            </div>
            <div class="slider-card" :class="getCardClass(1, activeCard)" @click="handleClick(1)">
              <div class="card-header">
                <h3><span class="iconfont icon-chuangxin"></span>创新</h3>
              </div>
              <div class="card-block">
                <h4>提高数据创新效率与生产力</h4>
                <div class="collapse-block">
                  <p>集合外脑力量，探寻最佳算法，解决实际问题</p>
                  <div class="card-img-container">
                    <img src="https://cdn.kesci.com/client/solution-white/crowd.png">
                    <img src="https://cdn.kesci.com/client/solution-white/competition.png">
                  </div>
                </div>
              </div>
              <div class="custom-border"></div>
              <div class="card-block">
                <h4>引领工业级算法创新</h4>
                <div class="collapse-block">
                  <p>构建企业在自身领域内的技术话语权</p>
                  <div class="card-img-container">
                    <img src="https://cdn.kesci.com/client/solution-white/leadboard.png">
                  </div>
                </div>
              </div>
              <div class="custom-border"></div>
              <div class="card-block">
                <div class="place-holder"></div>
                <!-- <div class="collapse-block">
                  <p>助力企业招募数据人才、组建AI团队，提供培训服务</p>
                  <div class="card-img-container">
                    <img src="../assets/production-white/数据人才精准招聘.png">
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-block bg-case">
        <div class="container">
          <div class="case-flex-wrapper" key="0" v-show ="activeCard === -1">
            <div class="case-card">
              <div class="img-container">
                <img src="https://cdn.kesci.com/client/logo/v2/TAL.png">
              </div>
              <h5>好未来</h5>
              <p>引领科技教育，探索AI实训落地 </p>
            </div>
            <div class="case-card">
              <div class="img-container">
                <img src="https://cdn.kesci.com/client/logo/v2/nanjing.png">
              </div>
              <h5>南京市人民政府</h5>
              <p>协办2018全球（南京）人工智能应用大赛 <br/>助力南京市塑造产业活力，推进创新名城建设</p>
            </div>
            <div class="case-card">
              <div class="img-container">
                <img src="https://cdn.kesci.com/client/logo/v2/soda.png">
              </div>
              <h5>上海市经信委</h5>
              <p>上海SODA开放数据创新应用大赛<br/>发掘城市数据价值 </p>
            </div>
          </div>
          <div class="case-flex-wrapper" key="1" v-show ="activeCard === 0">
            <div class="case-card">
              <div class="img-container">
                <img src="https://cdn.kesci.com/client/logo/v2/liantong.png">
              </div>
              <h5>中国联通</h5>
              <p>扩大 “智慧创投” 品牌影响力<br/>助力数据人才、企业的筛选和创新生态的构建</p>
            </div>
            <div class="case-card">
              <div class="img-container">
                <img src="https://cdn.kesci.com/client/logo/v2/zhaoshang.png">
              </div>
              <h5>招商银行</h5>
              <p>塑造招行科技雇主品牌影响力<br/>引进数据创新平台</p>
            </div>
            <div class="case-card">
              <div class="img-container">
                <img src="https://cdn.kesci.com/client/logo/v2/ICBC.png">
              </div>
              <h5>中国工商银行</h5>
              <p>构建工行专属数据创新平台<br/>提升数据创新能力</p>
            </div>
          </div>
          <div class="case-flex-wrapper" key="-1" v-show ="activeCard === 1">
            <div class="case-card">
              <div class="img-container">
                <img src="https://cdn.kesci.com/client/logo/v2/ctrip.png">
              </div>
              <h5>携程</h5>
              <p>提升数据创新效率，降低运营成本<br/>高效完成多条业务线的技术升级</p>
            </div>
            <div class="case-card">
              <div class="img-container">
                <img src="https://cdn.kesci.com/client/logo/v2/kuaishou.png">
              </div>
              <h5>快手</h5>
              <p>通过算法众包建立更精准的用户行为预测模型<br/>用数据赋能增长</p>
            </div>
            <div class="case-card">
              <div class="img-container">
                <img src="https://cdn.kesci.com/client/logo/v2/tongdun.png">
              </div>
              <h5>同盾科技</h5>
              <p>聚焦行业前沿课题，引领工业级算法创新<br/>建立数据科技品牌影响力 </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeCard: 0,
      timer: null
    };
  },
  beforeRouteEnter(from, to, next) {
    next((vm) => {
      vm.setupTimer();
    });
  },
  beforeRouteLeave(from, to, next) {
    this.clearTimer();
    next();
  },
  methods: {
    setupTimer() {
      this.timer = window.setTimeout(() => {
        this.slideNext();
        this.setupTimer();
      }, 3000);
    },
    clearTimer() {
      if (this.timer) {
        window.clearTimeout(this.timer);
      }
    },
    slideNext() {
      if (this.activeCard === 1) {
        this.activeCard = -1;
      } else {
        this.activeCard++;
      }
    },
    handleClick(index) {
      this.activeCard = index;
      this.clearTimer();
      this.setupTimer();
    },
    getCardClass(index, activeCard) {
      const delta = index - activeCard;
      if (delta === 0) {
        return 'center';
      };
      if (delta < 0) {
        return delta === -1 ? 'left' : 'right';
      }
      if (delta > 0) {
        return delta === 1 ? 'right' : 'left';
      }
    }
  }
};
</script>

<style lang="scss">
.production-page {
  .normal-header-block {
    background-image: url("../assets/banners/product.png");
  }
  .bg-industry {
    background-image: url('../assets/bg-production.jpg');
    background-size: cover;
    .industry-header {
      h2, h3 {
        color: #fff;
      }
    }
  }
  .bg-solution {
    background-image: url('../assets/bg-production-solution.jpg');
    background-size: cover;
  }
  .industry-icon-container {
    display: flex;
    justify-content: space-between;
  }
  .industry-backgound-container {
    background-image: url('../assets/bg-rectangle.png');
    background-size: 100% 56px;
    // background-color: #000;
    height: 56px;
    width: 100%;
  }
  .industry-icon-container {
    display: flex;
    justify-content: space-between;
    padding: 0px 48px 32px 48px;
    text-align: center;
    p {
      color: #93a0ad;
    }
    .iconfont {
      display: block;
      color: #93a0ad;
      font-size: 40px;
    }
  }
  .industry-list-container {
    background-color: #fff;
    border-radius: 0px 0px 4px 4px;
    padding: 0px 48px 48px 48px;
    margin-top: -1px;
    .block-header {
      margin-bottom: 64px;
      h2 {
        margin-top: 0px;
      }
    }
    .industry-list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 32px 0px;
      img {
        width: 200px;
      }
      h3 {
        font-size: 24px;
        font-weight: 500;
      }
    }
    .custom-border {
      height: 1px;
      background: linear-gradient(to right, #979797, #979797 6px, transparent 6px, transparent);
      background-size: 12px 100%;
    }
  }
  .solution-slider-container {
    width: 100%;
    height: 640px;
    position: relative;
    perspective: 400px;
    perspective-origin: 50% 50%;
    .slider-card {
      cursor: pointer;
      width: 500px;
      position: absolute;
      top: 0;
      left: calc(50% - 250px);
      text-align: center;
      background-color: #002040;
      h3, h4, p {
        color: #fff;
      }
      h3 {
        font-size: 24px;
        margin: 0;
      }
      h4 {
        margin-bottom: 0px;
      }
      img {
        height: 32px;
      }
      .iconfont {
        font-size: 20px;
        margin-right: 8px;
      }
      .card-header {
        position: static;
        padding: 14px;
        background-color: #006EFF;
      }
      .card-block {
        position: static;
        padding: 32px 24px 48px 24px;
      }
      .collapse-block {
        transition: height ease 1s;
        overflow: hidden;
        height: 84px;
      }
      .card-img-container {
        margin-top: 24px;
        display: flex;
        justify-content: space-around;
      }
      .place-holder {
        height: 40px;
        width: 100%;
      }
      .custom-border {
        height: 1px;
        margin: 0 auto;
        background: linear-gradient(to right, #979797, #979797 6px, #002040 6px, #002040);
        background-size: 12px 100%;
        width: 300px;
      }
      transition: transform ease 1s, width ease 1s, left ease 1s;
      &.center {
        transform: translate3d(0, 0, 0);
        z-index: 3;
        box-shadow: 0px 0px 23px 0px rgba(23, 128, 224, 0.12);
      }
      &.left {
        width: 340px;
        left: calc(50% - 170px);
        transform: translate3d(-380px, 120px, -50px);
        z-index: 2;
        .collapse-block {
          height: 0px;
        }
      }
      &.right {
        width: 340px;
        left: calc(50% - 170px);
        transform: translate3d(380px, 120px, -50px);
        z-index: 1;
        .collapse-block {
          height: 0px;
        }
      }
    }
  }
  .case-flex-wrapper {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .case-card {
    text-align: center;
    background-color: #fff;
    position: relative;
    width: 30%;
    padding: 15px 24px;
    h5 {
      font-size: 16px;
    }
    p {
      color: #6E767F;
    }
    .img-container {
      height: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        height: 40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/production.vue